export default __webpack_public_path__ + "static/media/oscer-pres-bruising.fc512689.svg";